<template>
  <div class="wrap">
    <div class="card">
      <h2>请输入 Token</h2>
      <p class="hint">用于访问 /api/*（Authorization: Bearer ...）</p>

      <input
        v-model.trim="token"
        type="password"
        placeholder="API Token"
        @keyup.enter="save"
      />

      <div class="row">
        <button :disabled="loading || !token" @click="save">
          {{ loading ? "验证中..." : "保存并验证" }}
        </button>
      </div>

      <p v-if="error" class="error">{{ error }}</p>

      <details class="help">
        <summary>提示</summary>
        <ul>
          <li>Token 在 Cloudflare Pages 环境变量中配置（API_TOKEN）。</li>
          <li>本地 dev 用 .dev.vars 的 API_TOKEN。</li>
        </ul>
      </details>
    </div>
  </div>
</template>

<script>
import { setToken, clearToken, api } from "@/api/client";

export default {
  name: "Login",
  data() {
    return { token: "", loading: false, error: "" };
  },
  methods: {
    async save() {
      this.error = "";
      this.loading = true;
      try {
        setToken(this.token);
        await api.ping(); // 验证 token 是否有效
        this.$router.replace("/");
      } catch (e) {
        clearToken();
        this.error = e && e.message ? e.message : "验证失败";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f6f7fb; padding: 24px; }
.card { width: 420px; max-width: 100%; background: #fff; border-radius: 12px; padding: 20px; box-shadow: 0 10px 30px rgba(0,0,0,.08); }
.hint { margin: 6px 0 14px; color: #666; font-size: 13px; }
input { width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 14px; }
.row { margin-top: 12px; display: flex; gap: 10px; }
button { padding: 10px 12px; border: 0; border-radius: 8px; background: #1f6feb; color: #fff; cursor: pointer; width: 100%; }
button:disabled { opacity: .6; cursor: not-allowed; }
.error { margin-top: 10px; color: #b42318; font-size: 13px; }
.help { margin-top: 12px; color: #444; font-size: 13px; }
</style>